import axios from "axios";

// base interceptor with common configurations for all requests
const apiClient = axios.create({
  baseURL: 'https://blog.tasks.market/wp-json/wp/v2/',
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor for adding auth token
apiClient.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem("accessToken");
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
},
(error)=>{
  return Promise.reject(error);
}
);


// Response interceptor for handling common errors
apiClient.interceptors.response.use(
  (response)=> response,
  (error)=>{
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
     
);

export default apiClient